import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormControlLabel, MenuItem, Select } from '@material-ui/core';
import { GreenCheckbox } from '../../../../components/FlowConfigurationInputs';
/**
 * @Description This function lets you return Schedule Backup.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function ScheduleBackup() {
    const { t } = useTranslation();
    const label = 'CONTENT.SETTINGS.GENERAL.';
    const [file, setFile] = useState();
    const handleFileChange = (e) => {
        setFile(e.target.files[0]?.name);
    }
    return (
        <>
        <div className="sgeneral-row-body">
            <div><span>{t(label + 'INITIATE')}</span>
                <Select className="sgeneral-select" variant="outlined">
                    <MenuItem value="incremental"><span className="sgeneral-day">{t(label + 'INCREMENTAL')}</span></MenuItem>
                    <MenuItem value="full"><span className="sgeneral-day">{t(label + 'FULL')}</span></MenuItem>
                    <MenuItem value="partial"><span className="sgeneral-day">{t(label + 'PARTIAL')}</span></MenuItem>
                </Select>
            </div>
            <div><span>{t(label + 'STARTS')}</span>
                <Select className="sgeneral-select" variant="outlined">
                    <MenuItem value="weekly"><span className="sgeneral-day">{t(label + 'WEEKLY')}</span></MenuItem>
                    <MenuItem value="daily"><span className="sgeneral-day">{t(label + 'DAILY')}</span></MenuItem>
                    <MenuItem value="monthly"><span className="sgeneral-day">{t(label + 'MONTHLY')}</span></MenuItem>
                </Select>
            </div>
            <div><span>{t(label + 'AT')}</span>
                <input type="time" className="sgeneral-day"/>
            </div>
            <div><span>{t(label + 'REPEATS')}</span>
                <input type="number" min="0" className="sgeneral-day"/>
                <Select className="sgeneral-select" variant="outlined">
                    <MenuItem value="hours"><span className="sgeneral-day">{t(label + 'HOURS')}</span></MenuItem>
                </Select>
            </div>
            <div><span>{t(label + 'DAYS')}</span>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'MONDAY')}</span>}/>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'TUESDAY')}</span>}/>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'WEDNESDAY')}</span>}/>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'THURSDAY')}</span>}/>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'FRIDAY')}</span>}/>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'SATURDAY')}</span>}/>
                <FormControlLabel control={<GreenCheckbox/>} label={<span className="sgeneral-day">{t(label + 'SUNDAY')}</span>}/>
            </div>
        </div>
        <div className="sgeneral-row backup">
            <div>
                <span className="sgeneral-header">{t(label + 'PATH')}</span>
            </div>
        </div>
        <div className="sgeneral-row-body backup">
            <div>
            <div className="custom-file">
                <input type="file" className="custom-file-input" id="sgeneral-customFile" onChange={handleFileChange}/>
                <label className="custom-file-label" htmlFor="sgeneral-customFile">{file ? file : t(label + 'CHOOSE')}</label>
            </div>
            </div>
            <div>
            <button>{t(label + 'BACKUP')}</button>
            <button>{t(label + 'HISTORY')}</button>
            </div>
        </div>
        </>
    )
}
export default ScheduleBackup;